<template>
    <div class="video-wrapper" v-bind:style="height">
<!--        <div v-show="expanded" class="controls-wrapper">
            <div class="controls">
                <button v-on:click="play()">Play</button>
            </div>
        </div>-->
      <div class="video-item w-100" ref="videoItem" v-on:click="$emit('video-click')" v-bind:class="{'closed': !expanded}">
            <video ref="video" width="100%" class="d-block" :src="videoRootPath + project.videos.video[0].url"></video>
        </div>
    </div>
</template>


<script>
    export default {
        name: "TileSlider",
        props: {
            project: {},
            aspectratio: {
                default: 3.2,
                type: Number
            },
            expanded: {
                default: false,
                type: Boolean
            }
        },
        data: function () {
            return {
                height: {},
                videoElement: null,
                videoRootPath: "https://www.robinjuenkersfeld.de/videos/",
            };

        },
        computed: {

            wrapperHeight: function () {
                let cropHeight = 100 / this.aspectratio / 2;
                return {
                    paddingTop: cropHeight + '%',
                    paddingBottom: cropHeight + '%',
                };

            },
            imageHeight: function () {
                let halfHeight = (this.$refs.videoItem.offsetHeight / 2);

                return {
                    paddingTop: halfHeight + 'px',
                    paddingBottom: halfHeight + 'px',
                };
            },
        },

        watch: {
            expanded: function () {
                if (!this.expanded) {
                    this.height = this.wrapperHeight;
                    this.$refs.video.pause();
                } else {
                    this.height = this.imageHeight;
                    this.$refs.video.play();
                }
            }
        },

        methods: {
            play: function(){
                this.$refs.video.play();
                console.log('play');
            }



        },
        mounted() {
            var $this = this;
            // Register an event listener when the Vue component is ready
            this.height = this.wrapperHeight;
            this.$nextTick(function () {
                // DOM is now updated
                // `this` is bound to the current instance
                $this.videoElement = $this.$refs.video
            })
        },
    };
</script>
